import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { isTenantUser, isTenantAllowedAppPath } from '../../lib/authRoles';
import MainLayout from './MainLayout';
import TenantLayout from './TenantLayout';

/**
 * Picks owner vs tenant chrome before any sidebar renders.
 * Uses role from the live user object so stale isTenant flags cannot leak owner nav.
 */
export const AppShell = () => {
  const { loading, isAuthenticated, user } = useAuth();
  const location = useLocation();
  const tenantUser = isTenantUser(user);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
          <div className="animate-spin rounded-full h-8 w-8 border-2 border-domio-600 border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (tenantUser) {
    if (!isTenantAllowedAppPath(location.pathname)) {
      return <Navigate to="/app/tenant" replace />;
    }
    return <TenantLayout />;
  }

  if (
    location.pathname === '/app/tenant' ||
    location.pathname.startsWith('/app/tenant/')
  ) {
    return <Navigate to="/app/dashboard" replace />;
  }

  return <MainLayout />;
};

export default AppShell;
